module.exports = __webpack_public_path__ + "21717cb3c28092ace17a0bdd18707c72.png";